// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__texgG","title":"BackImages_title__rLqHh","images":"BackImages_images__yD-v9"};